<template>
  <el-card>
    <el-alert
      v-if="ownerError || error"
      :title="ownerError || error"
      type="error"
      :closable="false"
    />
    <el-form inline size="small" @submit.native.prevent="search">
      <el-form-item label="货主">
        <el-select
          v-model="filters.customerId"
          clearable
          filterable
          remote
          :remote-method="q => searchOwners(q, filters.customerId)"
          :loading="customerLoading"
          :disabled="!!boundCustomerId || !ownerReady"
        >
          <el-option
            v-for="customer in customers"
            :key="customer.customerId"
            :label="customer.name"
            :value="customer.customerId"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="filters.taskType" clearable>
          <el-option
            v-for="(label, value) in types"
            :key="value"
            :label="label"
            :value="value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="filters.status" clearable>
          <el-option
            v-for="(label, value) in statuses"
            :key="value"
            :label="label"
            :value="value"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="归并状态">
        <el-select
          v-model="filters.mergeStatus"
          clearable
          data-test="merge-filter"
        >
          <el-option
            v-for="(label, value) in mergeStatuses"
            :key="value"
            :label="label"
            :value="value"
          />
          <el-option label="未分类" value="UNCLASSIFIED" />
        </el-select>
      </el-form-item>
      <el-button type="primary" :disabled="!ownerReady" @click="search"
        >查询</el-button
      >
    </el-form>
    <el-table v-loading="loading" :data="rows" border>
      <el-table-column prop="operationId" label="任务号" min-width="230" />
      <el-table-column prop="customerId" label="货主" min-width="120" />
      <el-table-column prop="inboundOrderId" label="入库单" min-width="180" />
      <el-table-column label="类型" width="110">
        <template slot-scope="scope">
          <el-tag :type="typeTagTypes[scope.row.taskType] || ''">
            {{ taskTypeName(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="170">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row)">
            {{ statusName(scope.row) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="归并状态" min-width="130">
        <template slot-scope="scope">{{ mergeName(scope.row) }}</template>
      </el-table-column>
      <el-table-column prop="gmtCreate" label="创建时间" width="170" />
      <el-table-column label="操作" width="140"
        ><template slot-scope="scope"
          ><el-button
            type="text"
            data-test="detail"
            @click="showDetail(scope.row.operationId)"
            >详情</el-button
          >
          <el-button
            v-if="canMerge(scope.row)"
            type="text"
            data-test="open-merge"
            :disabled="merging || mergeLoading"
            @click="showMerge(scope.row.operationId)"
            >归并</el-button
          ></template
        ></el-table-column
      >
    </el-table>
    <el-pagination
      :current-page="pageIndex"
      :page-size="20"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="changePage"
    />
    <el-dialog title="仓单业务任务" :visible.sync="visible" width="850px">
      <template v-if="selected">
        <el-descriptions
          class="operation-info"
          title="基本信息"
          :column="2"
          size="medium"
          border
          :label-style="{ width: '104px', whiteSpace: 'nowrap' }"
          :content-style="{ overflowWrap: 'anywhere' }"
        >
          <el-descriptions-item label="任务号">
            {{ selected.operationId }}
          </el-descriptions-item>
          <el-descriptions-item label="通知号">
            {{ selected.notifyId }}
          </el-descriptions-item>
          <el-descriptions-item label="货主">
            {{ selected.customerId }}
          </el-descriptions-item>
          <el-descriptions-item label="入库单">
            {{ selected.inboundOrderId }}
          </el-descriptions-item>
          <el-descriptions-item label="类型">
            <el-tag :type="typeTagTypes[selected.taskType] || ''">
              {{ taskTypeName(selected) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="statusTagType(selected)">
              {{ statusName(selected) }}
            </el-tag>
          </el-descriptions-item>
          <el-descriptions-item
            v-if="selected.taskType === OperationType.UNLOCK"
            label="解锁类型"
          >
            {{ unlockTypes[selected.unlockType] || selected.unlockType }}
          </el-descriptions-item>
          <el-descriptions-item
            v-if="selected.taskType === OperationType.UNLOCK"
            label="原任务号"
          >
            {{ selected.unlockRefNo }}
          </el-descriptions-item>
          <el-descriptions-item
            v-if="selected.taskType === OperationType.TRANSFER"
            label="原锁仓任务"
          >
            {{ selected.transferRefNo }}
          </el-descriptions-item>
          <el-descriptions-item
            v-if="selected.transferCustomerId"
            label="接收货主"
          >
            {{ selected.transferCustomerId }}
          </el-descriptions-item>
          <el-descriptions-item
            v-if="
              selected.taskType === OperationType.TRANSFER &&
                selected.transferOutboundOrderId
            "
            label="原货主出库单"
          >
            <router-link
              :to="{
                path: '/warehouseReceipt/outbound',
                query: { outboundOrderId: selected.transferOutboundOrderId }
              }"
              >{{ selected.transferOutboundOrderId }}</router-link
            >
          </el-descriptions-item>
          <el-descriptions-item
            v-if="selected.transferInboundOrderId"
            label="接收方入库单"
          >
            <router-link
              :to="{
                path: '/warehouseReceipt/inbound',
                query: { inboundOrderId: selected.transferInboundOrderId }
              }"
              >{{ selected.transferInboundOrderId }}</router-link
            >
          </el-descriptions-item>
        </el-descriptions>
        <el-descriptions
          class="operation-info"
          title="审核信息"
          :column="2"
          size="medium"
          border
          :label-style="{ width: '104px', whiteSpace: 'nowrap' }"
          :content-style="{ overflowWrap: 'anywhere' }"
        >
          <el-descriptions-item label="操作人">
            {{ selected.operatorUserName || "—" }}
          </el-descriptions-item>
          <el-descriptions-item label="处理时间">
            {{ selected.optTime || "—" }}
          </el-descriptions-item>
          <el-descriptions-item
            v-if="
              selected.taskType === OperationType.TRANSFER &&
                selected.approvedTime
            "
            label="批准时间"
            :span="2"
          >
            {{ selected.approvedTime }}
          </el-descriptions-item>
        </el-descriptions>
        <el-alert
          v-if="selected.executionError"
          :title="selected.executionError"
          type="error"
          :closable="false"
        />
        <el-descriptions
          v-if="
            selected.taskType === OperationType.TRANSFER &&
              selected.approvedTime
          "
          title="执行进度"
          :column="3"
          border
        >
          <el-descriptions-item label="进度">{{
            executionNames[selected.executionProgress] || "等待仓库处理"
          }}</el-descriptions-item>
          <el-descriptions-item label="原货主出库">{{
            wmsName(selected.transferOutboundWmsStatus)
          }}</el-descriptions-item>
          <el-descriptions-item label="汇银入库">{{
            wmsName(selected.transferInboundWmsStatus)
          }}</el-descriptions-item>
        </el-descriptions>
        <template v-if="selected.taskType === OperationType.TRANSFER">
          <el-descriptions
            title="关务归并"
            :column="2"
            border
            class="operation-info"
          >
            <el-descriptions-item label="归并状态">{{
              mergeName(selected)
            }}</el-descriptions-item>
            <el-descriptions-item label="确认人">{{
              selected.mergeConfirmUserName || "—"
            }}</el-descriptions-item>
            <el-descriptions-item label="确认时间">{{
              selected.mergeConfirmTime || "—"
            }}</el-descriptions-item>
            <el-descriptions-item label="归并备注" :span="2">{{
              selected.mergeRemark || "—"
            }}</el-descriptions-item>
          </el-descriptions>
          <el-alert
            v-if="selected.mergeStatus === MergeStatus.PENDING"
            title="请关务完成所有差异明细的调拨归并后整单确认。此前汇银整张入库单（包括序号一致的明细）不能下发，原货主出库不受影响。"
            type="warning"
            :closable="false"
            data-test="merge-warning"
          />
        </template>
        <h3 class="operation-items-title">申请明细</h3>
        <el-table :data="selected.items" border>
          <el-table-column
            prop="batchId"
            :label="
              selected.unlockType === UnlockType.OWNERSHIP_TRANSFER_UNLOCK
                ? '来源批次'
                : 'WMS批次'
            "
          />
          <el-table-column
            v-if="selected.unlockType === UnlockType.OWNERSHIP_TRANSFER_UNLOCK"
            prop="targetBatchId"
            label="汇银批次"
          />
          <el-table-column prop="itemNo" label="料号" min-width="160" />
          <el-table-column prop="skuName" label="商品名称" min-width="180" />
          <el-table-column prop="barcode" label="商品条码" min-width="150" />
          <el-table-column
            prop="productionDate"
            label="生产日期"
            min-width="120"
          />
          <el-table-column prop="expireDate" label="失效日期" min-width="120" />
          <el-table-column prop="quantity" label="申请数量" />
          <el-table-column
            v-if="selected.taskType === OperationType.TRANSFER"
            label="来源序号"
            min-width="110"
          >
            <template slot-scope="scope">{{
              scope.row.sourceItemRecordNo || "—"
            }}</template>
          </el-table-column>
          <el-table-column
            v-if="selected.taskType === OperationType.TRANSFER"
            label="汇银序号"
            min-width="110"
          >
            <template slot-scope="scope">{{
              scope.row.targetItemRecordNo || "—"
            }}</template>
          </el-table-column>
          <el-table-column
            v-if="selected.taskType === OperationType.TRANSFER"
            label="序号差异"
            min-width="110"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="hasMergeDifference(scope.row)"
                type="warning"
                data-test="merge-difference"
                >序号不一致</el-tag
              >
              <span v-else>—</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="selected.taskType === OperationType.TRANSFER"
            prop="shippedQty"
            label="实出数量"
          />
          <el-table-column
            v-if="selected.taskType === OperationType.TRANSFER"
            prop="receivedQty"
            label="实收数量"
          />
          <el-table-column
            v-if="selected.taskType === OperationType.LOCK"
            prop="lockedQty"
            label="剩余锁定余额"
          />
        </el-table>
      </template>
      <span slot="footer">
        <el-button @click="visible = false">关闭</el-button>
        <el-button
          v-if="canRetryCompletion"
          type="primary"
          :loading="reviewing"
          data-test="retry-completion"
          @click="retryCompletion"
          >重试完成</el-button
        >
        <template v-if="canReview">
          <el-button
            :disabled="reviewing"
            data-test="reject"
            @click="review(OperationStatus.REJECTED)"
            >驳回</el-button
          >
          <el-button
            type="primary"
            :loading="reviewing"
            data-test="confirm"
            @click="review(OperationStatus.CONFIRMED)"
            >{{
              selected.taskType === OperationType.TRANSFER
                ? "批准转移"
                : selected.taskType === OperationType.UNLOCK
                ? "确认解锁"
                : "确认锁仓"
            }}</el-button
          >
        </template>
      </span>
    </el-dialog>
    <el-dialog
      title="关务调拨归并"
      :visible="mergeVisible"
      :before-close="closeMerge"
      width="750px"
      :close-on-click-modal="!merging"
      :close-on-press-escape="!merging"
      :show-close="!merging"
    >
      <el-alert
        v-if="mergeError"
        :title="mergeError"
        type="error"
        :closable="false"
        data-test="merge-error"
      />
      <div v-if="mergeLoading" v-loading="mergeLoading" style="height: 80px" />
      <template v-if="mergeTask">
        <el-descriptions :column="2" border>
          <el-descriptions-item label="任务号">{{
            mergeTask.operationId
          }}</el-descriptions-item>
          <el-descriptions-item label="归并状态">{{
            mergeName(mergeTask)
          }}</el-descriptions-item>
          <el-descriptions-item label="确认人">{{
            mergeTask.mergeConfirmUserName || "—"
          }}</el-descriptions-item>
          <el-descriptions-item label="确认时间">{{
            mergeTask.mergeConfirmTime || "—"
          }}</el-descriptions-item>
          <el-descriptions-item label="归并备注" :span="2">{{
            mergeTask.mergeRemark || "—"
          }}</el-descriptions-item>
        </el-descriptions>
        <el-alert
          v-if="mergeTask.mergeStatus === MergeStatus.PENDING"
          type="warning"
          :closable="false"
          title="请关务完成所有差异明细的调拨归并后整单确认。此前汇银整张入库单（包括序号一致的明细）不能下发，原货主出库不受影响。本操作不会直接增加库存。"
          data-test="merge-warning"
        />
        <el-table :data="mergeTask.items" border>
          <el-table-column prop="itemNo" label="料号" />
          <el-table-column prop="quantity" label="数量" width="90" />
          <el-table-column prop="sourceItemRecordNo" label="来源序号" />
          <el-table-column prop="targetItemRecordNo" label="汇银序号" />
          <el-table-column label="差异"
            ><template slot-scope="scope">
              <el-tag
                v-if="hasMergeDifference(scope.row)"
                type="warning"
                data-test="merge-difference"
                >序号不一致</el-tag
              >
              <span v-else>—</span>
            </template></el-table-column
          >
        </el-table>
        <el-form v-if="canConfirmMerge" label-width="90px">
          <el-form-item label="归并备注"
            ><el-input
              v-model="mergeForm.remark"
              type="textarea"
              :maxlength="500"
              :disabled="merging"
              placeholder="选填"
              data-test="merge-remark"
          /></el-form-item>
        </el-form>
      </template>
      <span slot="footer">
        <el-button
          :disabled="merging"
          @click="closeMerge"
          data-test="cancel-merge"
          >关闭</el-button
        >
        <el-button
          v-if="canConfirmMerge"
          type="primary"
          :loading="merging"
          data-test="confirm-merge"
          @click="confirmMerge"
          >确认归并完成</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>
<script>
import {
  MergeStatus,
  mergeStatuses,
  OperationStatus,
  OperationType,
  TransferProgress,
  UnlockType
} from "./receiptEnums";
import api from "@/api/warehouseReceipt";
import owner from "./owner";
import { wmsStatuses } from "./orderStatuses";
import hasPermission from "@/directive/permissionButton/hasPermission";

export default {
  name: "WarehouseReceiptOperations",
  mixins: [owner],
  data() {
    return {
      MergeStatus,
      mergeStatuses,
      mergeForm: { remark: "" },
      mergeTask: null,
      mergeVisible: false,
      mergeLoading: false,
      mergeRequestId: 0,
      mergeError: "",
      merging: false,
      OperationStatus,
      OperationType,
      UnlockType,
      unlockTypes: {
        [UnlockType.PLEDGE_UNLOCK]: "解押解锁",
        [UnlockType.OWNERSHIP_TRANSFER_UNLOCK]: "转移解锁"
      },
      executionNames: {
        [TransferProgress.WAIT_WMS]: "等待仓库处理",
        [TransferProgress.SINGLE_SIDE]: "单边完成，等待另一侧回执",
        [TransferProgress.QUANTITY_MISMATCH]: "数量不一致，请人工核实",
        [TransferProgress.LOCAL_PENDING]: "双边足额，待账册完成",
        [TransferProgress.CONFIRMED]: "已完成",
        [TransferProgress.INVALID_DOCUMENTS]: "配对单据异常"
      },
      filters: { customerId: "", taskType: "", status: "", mergeStatus: "" },
      types: {
        [OperationType.LOCK]: "锁仓",
        [OperationType.UNLOCK]: "解锁",
        [OperationType.TRANSFER]: "转移"
      },
      typeTagTypes: {
        [OperationType.LOCK]: "warning",
        [OperationType.UNLOCK]: "success",
        [OperationType.TRANSFER]: ""
      },
      statusTagTypes: {
        [OperationStatus.PENDING]: "warning",
        [OperationStatus.CONFIRMED]: "success",
        [OperationStatus.REJECTED]: "danger"
      },
      statuses: {
        [OperationStatus.PENDING]: "待审核",
        [OperationStatus.CONFIRMED]: "已确认",
        [OperationStatus.REJECTED]: "已驳回"
      },
      rows: [],
      pageIndex: 1,
      total: 0,
      loading: false,
      error: "",
      selected: null,
      visible: false,
      reviewing: false,
      requestId: 0
    };
  },
  computed: {
    canConfirmMerge() {
      return (
        this.mergeVisible && !this.mergeLoading && this.canMerge(this.mergeTask)
      );
    },
    canRetryCompletion() {
      return (
        this.selected &&
        this.selected.taskType === OperationType.TRANSFER &&
        this.selected.status === OperationStatus.PENDING &&
        this.selected.canRetryCompletion &&
        hasPermission.hasPermission(this.$route, "review")
      );
    },
    canReview() {
      return (
        this.selected &&
        !this.selected.approvedTime &&
        (this.selected.taskType === OperationType.TRANSFER ||
          this.selected.taskType === OperationType.LOCK ||
          (this.selected.taskType === OperationType.UNLOCK &&
            !!this.unlockTypes[this.selected.unlockType])) &&
        this.selected.status === OperationStatus.PENDING &&
        hasPermission.hasPermission(this.$route, "review")
      );
    }
  },
  async created() {
    if (await this.initOwner()) {
      this.filters.customerId = this.boundCustomerId;
      this.search();
    }
  },
  beforeDestroy() {
    this.requestId++;
  },
  methods: {
    mergeName(task) {
      return task.taskType === OperationType.TRANSFER
        ? this.mergeStatuses[task.mergeStatus] || "未分类"
        : "—";
    },
    hasMergeDifference(item) {
      return (
        !!item.sourceItemRecordNo &&
        !!item.targetItemRecordNo &&
        item.sourceItemRecordNo !== item.targetItemRecordNo
      );
    },
    canMerge(task) {
      return !!(
        task &&
        task.taskType === OperationType.TRANSFER &&
        task.status === OperationStatus.PENDING &&
        task.approvedTime &&
        task.mergeStatus === MergeStatus.PENDING &&
        hasPermission.hasPermission(this.$route, "confirmMerge")
      );
    },
    closeMerge() {
      if (this.merging) return;
      this.mergeRequestId++;
      this.mergeLoading = false;
      this.mergeVisible = false;
      this.mergeTask = null;
    },
    async showMerge(operationId) {
      if (this.merging || this.mergeLoading) return;
      const requestId = ++this.mergeRequestId;
      this.error = "";
      this.mergeError = "";
      this.mergeForm = { remark: "" };
      this.mergeTask = null;
      this.mergeVisible = true;
      this.mergeLoading = true;
      try {
        const task = await api.operations.load(operationId);
        if (requestId === this.mergeRequestId) this.mergeTask = task;
      } catch (error) {
        if (requestId === this.mergeRequestId)
          this.mergeError = "归并任务加载失败，请关闭后重试";
      } finally {
        if (requestId === this.mergeRequestId) this.mergeLoading = false;
      }
    },
    async confirmMerge() {
      if (!this.canConfirmMerge || this.merging) return;
      const operationId = this.mergeTask.operationId;
      const { remark } = this.mergeForm;
      this.merging = true;
      this.mergeError = "";
      try {
        try {
          await this.$confirm(
            "确认本任务所有序号差异已完成实际调拨归并？确认后将允许汇银整张入库单下发，本操作不会直接增加库存。",
            "确认归并完成"
          );
        } catch (cancel) {
          return;
        }
        await api.operations.confirmMerge(operationId, remark);
        this.mergeTask = null;
        const refreshDetail =
          this.selected && this.selected.operationId === operationId;
        if (refreshDetail) this.selected = null;
        this.mergeForm = { remark: "" };
        try {
          this.mergeTask = await api.operations.load(operationId);
          if (refreshDetail) this.selected = this.mergeTask;
        } catch (error) {
          this.mergeError = "确认已提交，详情刷新失败，请关闭后重新加载";
        }
        await this.changePage(this.pageIndex);
        if (this.error)
          this.mergeError = "确认已提交，列表刷新失败，请重新查询";
      } catch (error) {
        this.mergeError =
          error.msg || error.message || "归并确认未成功，请刷新核实";
      } finally {
        this.merging = false;
      }
    },
    taskTypeName(task) {
      return task.taskType === OperationType.UNLOCK
        ? this.unlockTypes[task.unlockType] || "解锁"
        : this.types[task.taskType] || task.taskType;
    },
    wmsName(status) {
      return wmsStatuses[status] || status || "—";
    },
    async retryCompletion() {
      if (!this.canRetryCompletion || this.reviewing) {
        return;
      }
      this.reviewing = true;
      const operationId = this.selected.operationId;
      try {
        await api.operations.retryTransferCompletion(operationId);
        await this.showDetail(operationId);
        await this.changePage(this.pageIndex);
      } catch (error) {
        await this.showDetail(operationId);
        this.error = "本地完成未成功，请核实执行异常后重试";
      } finally {
        this.reviewing = false;
      }
    },
    statusTagType(task) {
      if (
        task.status === OperationStatus.PENDING &&
        (task.executionError ||
          task.executionProgress === TransferProgress.QUANTITY_MISMATCH ||
          task.executionProgress === TransferProgress.SINGLE_SIDE)
      ) {
        return "warning";
      }
      return task.status === OperationStatus.PENDING && task.approvedTime
        ? "success"
        : this.statusTagTypes[task.status] || "info";
    },
    statusName(task) {
      if (
        task.status === OperationStatus.PENDING &&
        task.approvedTime &&
        task.executionProgress
      ) {
        return task.executionError
          ? "执行异常"
          : this.executionNames[task.executionProgress] || "已批准";
      }
      return task.status === OperationStatus.PENDING && task.approvedTime
        ? "已批准"
        : this.statuses[task.status] || task.status;
    },
    search() {
      this.changePage(1);
    },
    async changePage(page) {
      if (!this.ownerReady) {
        return;
      }
      this.pageIndex = page;
      const id = ++this.requestId;
      this.loading = true;
      this.error = "";
      try {
        const result = await api.operations.pageQuery({
          ...this.filters,
          pageIndex: page,
          pageSize: 20
        });
        if (id === this.requestId) {
          this.rows = result.items || [];
          this.total = result.total;
        }
      } catch (error) {
        if (id === this.requestId) {
          this.error = "任务查询失败，请重试";
          this.rows = [];
        }
      } finally {
        if (id === this.requestId) {
          this.loading = false;
        }
      }
    },
    async showDetail(operationId) {
      this.error = "";
      this.mergeError = "";
      try {
        this.selected = await api.operations.load(operationId);
        this.visible = true;
      } catch (error) {
        this.error = "任务详情加载失败，请重试";
      }
    },
    reviewMessage(status) {
      const task = this.selected;
      if (status === OperationStatus.CONFIRMED) {
        if (task.taskType === OperationType.TRANSFER) {
          return "批准后生成配对出入库单，请分别人工下发仓库，是否继续？";
        }
        return task.taskType === OperationType.UNLOCK
          ? "确认解锁该任务的库存？"
          : "确认锁定该任务的库存？";
      }
      if (task.taskType === OperationType.LOCK) {
        return "驳回后将释放该任务的预占库存，是否继续？";
      }
      return task.taskType === OperationType.UNLOCK &&
        task.unlockType === UnlockType.OWNERSHIP_TRANSFER_UNLOCK
        ? "驳回后仅解除本任务的额度预留，汇银库存仍保持锁定，是否继续？"
        : "驳回后仅解除本任务的额度预留，原质押库存仍保持锁定，是否继续？";
    },
    async review(status) {
      if (!this.canReview || this.reviewing) {
        return;
      }
      try {
        await this.$confirm(this.reviewMessage(status), "审核任务");
      } catch (cancel) {
        return;
      }
      this.reviewing = true;
      const operationId = this.selected.operationId;
      try {
        await api.operations.review(operationId, status);
        await this.showDetail(operationId);
        await this.changePage(this.pageIndex);
      } catch (error) {
        this.error =
          (error && (error.msg || error.message)) ||
          "审核未成功，请刷新任务状态后重试";
      } finally {
        this.reviewing = false;
      }
    }
  }
};
</script>

<style scoped>
.operation-info {
  margin-bottom: 24px;
}
.operation-info ::v-deep .el-descriptions__table {
  table-layout: fixed;
}
.operation-items-title {
  margin: 0 0 16px;
  font-size: 16px;
  color: #303133;
}
</style>
